import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { AgentPending } from "utils/helpers/agentConversationStore";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

// The reply arrives whole, so the line names the wait, not a step; it only changes once the wait really is long.
const waitOf = (key: string, longAfterMs: number) => [
  { afterMs: 0, key },
  { afterMs: longAfterMs, key: TranslationKeys.SupportIssue.AgentWorking5 },
];

const PhrasesByKind: Record<AgentPending["kind"], { afterMs: number; key: string }[]> = {
  message: [
    { afterMs: 0, key: TranslationKeys.SupportIssue.AgentWorking1 },
    { afterMs: 2000, key: TranslationKeys.SupportIssue.AgentWorking2 },
    { afterMs: 4500, key: TranslationKeys.SupportIssue.AgentWorking3 },
    { afterMs: 7000, key: TranslationKeys.SupportIssue.AgentWorking4 },
    { afterMs: 12000, key: TranslationKeys.SupportIssue.AgentWorking5 },
  ],
  prepare: waitOf(TranslationKeys.SupportIssue.AgentWorkingPrepare, 6000),
  send: waitOf(TranslationKeys.SupportIssue.AgentWorkingSend, 6000),
};

interface AgentWorkingLineProps {
  pending: AgentPending;
}

// Derived from time since the call started, so a reopened popper continues instead of restarting.
const AgentWorkingLine: React.FC<AgentWorkingLineProps> = ({ pending }) => {
  const phrases = PhrasesByKind[pending.kind];
  const [now, setNow] = React.useState(Date.now);
  const index = Math.max(
    phrases.findLastIndex((phrase) => phrase.afterMs <= now - pending.since),
    0
  );

  React.useEffect(() => {
    const next = phrases[index + 1];
    if (!next) return;
    const timer = window.setTimeout(() => setNow(Date.now()), Math.max(0, pending.since + next.afterMs - Date.now()));
    return () => window.clearTimeout(timer);
  }, [now, pending.since, phrases, index]);

  return (
    <Grid container className={cssExports.agentWorkingLine} role="status">
      {LocalizationHelperInstance.getFormattedMessage(phrases[index].key)}
      <span className={cssExports.agentWorkingDots} aria-hidden>
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </span>
    </Grid>
  );
};

export default React.memo(AgentWorkingLine);
